import React, { useState } from 'react';
import { css } from '@emotion/core';
import { Desktop, Tablet } from '../../constants/responsive';
import { useIntl } from 'gatsby-plugin-intl';

const JobRow = ({
  type = 'text',
  marginBottom = [20, 23, 20],
  name,
  required = false,
  options = [],
}) => {
  const [showHearFromOther, SetShowHearFromOther] = useState(false);
  const intl = useIntl();
  const pleaseChoose = {
    en: 'please choose',
    'zh-cn': '请选择',
    'zh-hk': '請選擇',
  }[intl.locale];
  const requiredMsg = {
    en: 'Required fields cannot be empty',
    'zh-cn': '必填项不能为空',
    'zh-hk': '必填項不能爲空',
  }[intl.locale];
  // 手机号区号前缀选项
  const phonePrefixOptions = [
    '+86',
    '+1',
    '+852',
    '+44',
    '+61',
    '+81',
    '+65',
    '+39',
    '+33',
    '+49',
    '+91',
  ];

  const canNotEmpty = (required, value, tipElement) => {
    if (required) {
      if (!value || value.match(/^[ ]*$/)) {
        tipElement.innerHTML = requiredMsg;
      } else {
        tipElement.innerHTML = '';
      }
    }
  };

  // 控件统一宽度：移动端占满，平板/桌面为定宽（表单整体居中）
  const controlWidth = css`
    width: 100%;
    ${Tablet} {
      width: 708px;
    }
    ${Desktop} {
      width: 742px;
    }
  `;

  // 输入框/下拉框统一视觉：白底 + 浅灰边框 + 圆角
  const controlStyle = css`
    box-sizing: border-box;
    border-radius: 8px;
    border: solid 1px #d9d9d9;
    background-color: #ffffff;
    color: #000000;
    width: 100%;
    height: 44px;
    padding: 0 12px;
    font-size: 14px;
    font-weight: normal;
    line-height: 1.43;
    outline: none;
    transition: border-color 0.2s;
    :focus {
      border-color: #ee2f79;
    }
    ::-webkit-input-placeholder {
      color: #b3b3b3;
    }
    :-moz-placeholder {
      color: #b3b3b3;
    }
    ::-moz-placeholder {
      color: #b3b3b3;
    }
    ${Desktop} {
      height: 40px;
    }
  `;

  // 错误提示：保持绝对定位，紧跟在控件下方
  const errorTipStyle = css`
    position: absolute;
    color: #ee2f79;
    font-size: 12px;
    line-height: 1.4;
    ${Tablet} {
      font-size: 14px;
    }
    ${Desktop} {
      font-size: 12px;
    }
  `;

  return (
    <div
      css={css`
        margin-bottom: ${marginBottom[0]}px;
        ${Tablet} {
          margin-bottom: ${marginBottom[1]}px;
        }
        ${Desktop} {
          margin-bottom: ${marginBottom[2]}px;
        }
      `}
    >
      <h5
        css={css`
          span {
            color: #ee2f79;
            margin-right: 2px;
          }
          display: block;
          color: #000000;
          margin: 0 0 8px 0;
          font-size: 14px;
          font-weight: 500;
          line-height: 1.29;
          ${Tablet} {
            font-size: 18px;
            font-weight: 500;
            line-height: 1.11;
            margin-bottom: 12px;
          }
          ${Desktop} {
            font-size: 16px;
            font-weight: 500;
            line-height: 1.25;
            margin-bottom: 10px;
          }
        `}
      >
        {required && <span>*</span>}
        {intl.formatMessage({ id: `career.job.form.${name}` })}
      </h5>
      {type === 'text' && (
        <div
          css={css`
            position: relative;
            ${controlWidth};
          `}
        >
          <input
            className={required ? 'text-required' : 'text-unRequired'}
            name={name}
            type='text'
            css={controlStyle}
            required
            onKeyUp={(e) => {
              let input = e.target;
              let tip = input.nextSibling;
              // 不能为空判断及提示
              canNotEmpty(required, input.value, tip);
            }}
          />
          {/* 错误提示 */}
          <div css={errorTipStyle}></div>
        </div>
      )}
      {type === 'phone' && (
        <div
          css={css`
            position: relative;
            display: flex;
            align-items: center;
            ${controlWidth};
          `}
        >
          <select
            name='phone-prefix'
            defaultValue='+86'
            css={css`
              appearance: none;
              -moz-appearance: none;
              -webkit-appearance: none;
              flex-shrink: 0;
              box-sizing: border-box;
              background: #ffffff url(/career/select-icon.png) no-repeat;
              background-position: right 10px center;
              background-size: 9px;
              border: solid 1px #d9d9d9;
              border-radius: 8px;
              color: #000000;
              width: 94px;
              height: 44px;
              padding: 0 26px 0 12px;
              margin-right: 8px;
              font-size: 14px;
              font-weight: normal;
              line-height: 1.43;
              outline: none;
              ${Desktop} {
                height: 40px;
              }
            `}
          >
            {phonePrefixOptions.map((prefix) => {
              return (
                <option value={prefix} key={`phone-prefix-${prefix}`}>
                  {prefix}
                </option>
              );
            })}
          </select>
          <div
            css={css`
              position: relative;
              flex: 1;
            `}
          >
            <input
              className={required ? 'text-required' : 'text-unRequired'}
              name={name}
              type='text'
              css={controlStyle}
              required
              onKeyUp={(e) => {
                let input = e.target;
                let tip = input.nextSibling;
                // 不能为空判断及提示
                canNotEmpty(required, input.value, tip);
              }}
            />
            {/* 错误提示 */}
            <div css={errorTipStyle}></div>
          </div>
        </div>
      )}
      {type === 'select' && (
        <div
          css={css`
            position: relative;
            ${controlWidth};
          `}
        >
          <div
            css={css`
              box-sizing: border-box;
              width: 100%;
              height: 44px;
              border-radius: 8px;
              border: solid 1px #d9d9d9;
              background-color: #ffffff;
              padding: 0 12px;
              ${Desktop} {
                height: 40px;
              }
            `}
          >
            <select
              name={name}
              css={css`
                // 去除浏览器select的默认样式，添加自定义按钮样式
                appearance: none;
                -moz-appearance: none;
                -webkit-appearance: none;
                background: url(/career/select-icon.png) no-repeat;
                background-position: right center;
                background-size: 9px;
                border: none;
                outline: none;
                box-sizing: border-box;
                color: #b3b3b3;
                width: 100%;
                height: 100%;
                padding: 0;
                font-size: 14px;
                font-weight: normal;
                line-height: 1.43;
                ${Tablet} {
                  background-size: 12px;
                }
                ${Desktop} {
                  background-size: 12px;
                }
              `}
              onChange={(e) => {
                // 每当下拉选择框值有所变动，就消除上一次的错误提示
                let errMsgDiv = e.target.parentElement.parentElement.lastChild;
                if (e.target.value === '') {
                  errMsgDiv.innerHTML = pleaseChoose;
                } else {
                  errMsgDiv.innerHTML = '';
                }
                // 已选择时文字转为黑色，未选择保持占位灰
                e.target.style.color = e.target.value ? '#000000' : '#b3b3b3';
                if (name === 'hear-from') {
                  if (e.target.value === 'other') {
                    SetShowHearFromOther(true);
                  } else {
                    SetShowHearFromOther(false);
                  }
                }
              }}
            >
              <option value=''>
                {
                  {
                    en: 'please choose',
                    'zh-cn': '请选择',
                    'zh-hk': '請選擇',
                  }[intl.locale]
                }
              </option>
              {options.map((key) => {
                return (
                  <option value={key} key={`${name}-${key}`}>
                    {name === 'location'
                      ? intl.formatMessage({
                          id: `career.job.locations.${key}`,
                        })
                      : intl.formatMessage({ id: `career.job.${name}.${key}` })}
                  </option>
                );
              })}
            </select>
          </div>
          {name === 'hear-from' && showHearFromOther && (
            <input
              id={`hear-from-other`}
              name='hear-from-other'
              onKeyUp={(e) => {
                let input = e.target;
                let tip = e.target.nextSibling;
                // 不能为空判断及提示
                canNotEmpty(required, input.value, tip);
              }}
              placeholder={
                {
                  en: 'If you choose others , please specify',
                  'zh-cn': '其他，请注明',
                  'zh-hk': '其他，請註明',
                }[intl.locale]
              }
              css={css`
                :-moz-placeholder {
                  color: #c4c4c4;
                }
                ::-webkit-input-placeholder {
                  color: #c4c4c4;
                }
                ::-moz-placeholder {
                  color: #c4c4c4;
                }
                width: 100%;
                border-bottom: 1px solid #ee2f79;
                font-weight: normal;
                padding: 1px 0;
                font-size: 12px;
                line-height: 1.67;
                margin-top: 20px;
                ${Tablet} {
                  font-size: 14px;
                  line-height: 1.43;
                  margin-top: 23px;
                }
                ${Desktop} {
                  margin-top: 20px;
                }
              `}
            />
          )}
          {/* 错误提示 */}
          <div className='select-errMsg' css={errorTipStyle}></div>
        </div>
      )}
      {type === 'textarea' && (
        <div
          css={css`
            position: relative;
            ${controlWidth};
          `}
        >
          <textarea
            className={required ? 'textarea-required' : 'textarea-unRequired'}
            name={name}
            css={css`
              ${controlStyle};
              height: 188px;
              padding: 12px;
              resize: none;
              ${Desktop} {
                height: 156px;
              }
            `}
            required
            placeholder={
              {
                en: '       *no more than 120 words',
                'zh-cn': '     *不超逾120字',
                'zh-hk': '     *不超逾120字',
              }[intl.locale]
            }
            onKeyUp={(e) => {
              let textarea = e.target;
              let tip = e.target.nextSibling;
              // 不能为空判断及提示
              canNotEmpty(required, textarea.value, tip);
              // 自我介绍限制字数
              if (name === 'about-you') {
                if (intl.locale === 'en') {
                  // 英文限制120个单词
                  // 正则判断:是英文单词
                  var lastWord = '';
                  if (
                    e.target.value.match(/\b[a-zA-Z]+\b/g) &&
                    e.target.value.match(/\b[a-zA-Z]+\b/g).length > 120
                  ) {
                    lastWord = e.target.value.match(/\b[a-zA-Z]+\b/g).slice(-1);
                    var lastIndex = e.target.value.lastIndexOf(lastWord);
                    e.target.value = e.target.value.slice(0, lastIndex);
                  }
                } else {
                  // 中文限制120个字符
                  e.target.value = e.target.value.substring(0, 120);
                }
              }
            }}
          ></textarea>
          {/* 错误提示 */}
          <div css={errorTipStyle}></div>
        </div>
      )}
    </div>
  );
};

export default JobRow;
